export const dailyCookieStorage = {
    setItem(key: string, value: string): void {
        const expires = new Date();
        expires.setDate(expires.getDate() + 1);
        expires.setHours(0, 0, 0, 0);

        document.cookie = key + '=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/';

    },

    getItem(key: string): string | null {
        let cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].split("=");
            if (key == cookie[0].trim()) {
                return decodeURIComponent(cookie[1]);
            }
        }
        return null;
    }
}
